import { useEventBus, type EventBusKey } from '@vueuse/core';

export type AppEvent =
  | { type: 'group:created'; groupUid: string; organizationUid: string }
  | { type: 'membership:updated'; organizationUid: string }
  | { type: 'association:updated'; userUids: string[] };

const appEventsKey: EventBusKey<AppEvent> = Symbol('lcp:app-events');

export function useAppEvents() {
  const bus = useEventBus(appEventsKey);

  return {
    emitAppEvent: (event: AppEvent) => bus.emit(event),
    /** Subscribe to all app events. Auto-unsubscribes on scope dispose. */
    onAppEvent: (handler: (event: AppEvent) => void) => bus.on(handler),
  };
}
